import qs from 'qs'

export default function getCoupon() {
    const { coupon } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return coupon
}